import { createRoot } from 'react-dom/client';

import { App } from './app';

// Create a container element in the DOM
const appContainer = document.createElement('div');
document.body.appendChild(appContainer);

// Create a root
const root = createRoot(appContainer); // createRoot(container!) if you are sure that container is non-null

root.render(<App />);
